<template>
    <span>
        <button class="btn-link"
                @click="viewItem()">
            <slot name="modal-link"></slot>
        </button>
        <!-- added close directive in order to reset the modal state -->
        <modal :show.sync="modals.classic" @close="resetModal" headerClasses="justify-content-center">
           <center>
    <div class="card card-body agatrs-card-style">
         <Header pageTitle="Edit Organization" class="card-container"></Header>
            <div class="col-md-12 center">
            
                <form @submit.prevent="updateOrganizations">
                    <div class="row ">
                        <div class="col-md-3 col-md-6">
                            <base-input type="text" label="Organization " placeholder="Organization Name" v-model="organization.name">
                            </base-input>
                        </div>
                        <div class="col-md-3 col-md-6">
                            <base-input label="Organization Abbreviation" v-model="organization.abbreviation" placeholder="Organization Abbreviation" addon-left-icon="tim-icons icon-single-02"></base-input>
                        </div>
                    </div>
                    <br>  
                     <base-button
              @click="resetModal()"
              class="btn btn-primary"
            >
              <i    class="tim-icons icon-double-left  center-btn-content "></i> Return to table
            </base-button>     
                    <!-- <router-link :to="'/admin/organizations'" class="btn primary"><span> Return to Table </span></router-link> -->
                     <base-button native-type="submit" type="primary" class="btn-fill">
                        Update Information
                    </base-button>
                    
                </form>
            </div>
    </div>
</center>
        </modal>
    </span>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { BaseButton, Modal } from "@/components";
    import axios from "@/axios";
    import Utility from "@/mixins/utility/utility";
    import swal from "sweetalert2";
    import Util from "@/util/util";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
    //import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Treeselect from "@riophae/vue-treeselect";
import {
    Select,
    Option
} from 'element-ui'
import Header from "@/components/App/Header.vue";

    export default {
        name: "organizational-edit",
         components: {
            Modal,
            BaseButton,
            Treeselect,
             [Select.name]: Select,
        [Option.name]: Option,
        Header
        },
        mixins: [Utility],
        props: {  
    id: {
      default: 0
    },
        },
        data() {
            return {
                organizationId: null,
                modals: {
                    classic: false,
                },
            };
        },
        mounted(){
            console.log(this.props.id);
             this.getOrganization(this.props.id)
        },

        computed: {
            ...mapGetters({
                jointStaffOrganizations: "organization/jointStaffOrganizations",
                organization: 'organization/organization',
            }),
        },
        methods: {
            ...mapActions({
                getJointStaffOrganizations: "organization/getJointStaffOrganizations",
                 updateOrganization: 'organization/updateOrganization',
            getOrganization: 'organization/getOrganization', 
            }),
            viewItem() {
                let ctx = this;
        this.getOrganization(this.id).then(()=>{
             ctx.modals.classic = true;
        })
            },
           
           
            // resets the modal state
            resetModal() {
                this.organizationId = null;
                this.errors.clear(); // clears all validation errors
                this.$validator.reset(); // reset the validator
                this.modals = this.modals || {}; 
                this.modals.classic = false;
            },
           
            getError(fieldName) {
                return this.errors.first(fieldName);
            },
             updateOrganizations(id) {
            let ctx = this;
            ctx.updateOrganization().then(()=>{
                ctx.getOrganization(this.id);
            });
            this.modals.classic = false;
        },
        returnToTable(){
            this.$router.push('/admin/organizations')
        }
        },
    };
</script>

<style>

.more-width{

    width: 50%;
}

.center-btn-content {
 height:18px; margin-right: 3px
}
</style>
